import * as Sentry from "@sentry/react";
import notificationStore from "../../stores/NotificationStore";

export default class ResponseHandler {

    public static onJson(e: Response) {

        if (e.status === 401) {
            window.location.reload();
        }
        if (e.ok) {
            return e.json()
        }
        return this.onError(e);

    }


    public static onError(e: MessageResponse): any {

        if (e.status === 401) {
            window.location.reload();
        }

        console.error("[MeetApp]::ResponseHandler-onError", e);
        var correlationId = Sentry.captureException(e); 

        if (e.message) {
            notificationStore.showToast(`${e}. cid:${correlationId}`, "error");
        } else {
            if (e.text) {
                e.text().then(t =>  notificationStore.showToast(`${t}. cid:${correlationId}`, "error"));
            } else {
                notificationStore.showToast(`${e.status}-${e.statusText}. cid:${correlationId}`, "error");
            }
        }

       return Promise.reject(e);
    }
}

interface MessageResponse extends Response {
    message?: string;
}

